/**
 * Глобальный store для тостов — позволяет вызывать toast из любого места (в т.ч. api/client).
 * ToastProvider регистрирует handler при монтировании.
 */
let handler = null

export function setToastHandler(fn) {
  handler = fn
}

export function showToast(message, type = 'success') {
  if (handler) handler(message, type)
}
